import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
import { DOMAIN } from "./domain-constant";
export default class JobsService extends ApiService {
  template = "defaultTemplate";
  namespace = "job";
  icon = "Briefcase2";
  favicon = "Briefcase";
  DOMAIN = DOMAIN.JOBS;
  action = "action";
  name = "Job";
  enableSchedular = true;
  search = true;
  singular = this.terminology.job.singular;
  plural = this.terminology.job.plural;
  vowel = this.terminology.job.vowel;
  Width = 1200;
  gemItems = [
    {
      key: "create",
      label: this.t("addAEntity", { entity: "Job" }),
      icon: PrimeIcons.PLUS_CIRCLE,
    },
    {
      key: "listing",
      label: this.t("allEntity", { entity: "Jobs" }),
      icon: PrimeIcons.LIST,
    },
  ];
  columns = [
    {
      header: this.t("number"),
      icon: "Shred",
      field: "number",
    },
    {
      header: this.t("displayName"),
      icon: "UserSilhouette",
      field: "display_name",
    },
    {
      header: this.t("customer"),
      icon: "UserSilhouette",
      field: "customer",
    },
    {
      header: this.t("contact"),
      icon: "UserSilhouette",
      field: "contact",
    },
    {
      header: this.t("phoneNumber"),
      icon: "MobilePhone",
      field: "phone",
    },

    {
      header: this.t("status"),
      icon: "Lightning",
      field: "status",
      template: (data) => {
        return this.parseStatus(data["status"]);
      },
    },
  ];
  filterItems = [
    { name: "Types", serviceId: "2", value: "2", realm: "2" },
    { name: "Categories", serviceId: "2", value: "3", realm: "1" },
    { name: "Folders", serviceId: "2", value: "-2", realm: "0" },
  ];
  constructor() {
    super("jobs");
  }
}
